<template>
  <div class="container-nzidoo">
    <loading-spinner v-if="loader" />
    <form v-else class="card mx-2 p-3" method="post" @submit.prevent="updatePassword">
      <!-- ACTIONS -->
      <div class="d-flex justify-content-between align-items-start mb-4">
        <button type="button" class="font-weight-bold text-primary mx-0" @click="$router.go(-1)">
          <i class="mdi mdi-arrow-left mr-2"></i>{{ $t("auth.change-password") }}
        </button>
        <button type="submit" class="btn-pill font-weight-bold text-primary">
          {{ $t("action.save") }}
        </button>
      </div>
      <div class="form-group mb-4">
        <label for="oldPassword">
          {{ $t("general.old") }} {{ $t("attr.password") }}
        </label>
        <input type="password" :class="'form-control ' + { 'is-invalid': has_error && errors.oldPassword }"
          id="oldPassword" v-model="passwordData.oldPassword" />
        <span class="help-block text-danger" v-if="has_error && errors.oldPassword">
          {{ errors.oldPassword[0] }}
        </span>
      </div>

      <div class="form-group mb-4">
        <label for="newPassword">
          {{ $t("general.new") }} {{ $t("attr.password") }}
        </label>
        <input type="password" :class="'form-control ' + { 'is-invalid': has_error && errors.newPassword }"
          id="newPassword" v-model="passwordData.newPassword" />
        <span class="help-block text-danger" v-if="has_error && errors.newPassword">
          {{ errors.newPassword[0] }}
        </span>
      </div>

      <div class="form-group mb-4">
        <label for="confirmPassword">
          {{ $t("action.confirm") }} {{ $t("attr.password") }}
        </label>
        <input type="password" :class="'form-control ' + { 'is-invalid': has_error && errors.confirmPassword }"
          id="confirmPassword" v-model="passwordData.confirmPassword" />
        <span class="help-block text-danger" v-if="has_error && errors.confirmPassword">
          {{ errors.confirmPassword[0] }}
        </span>
      </div>

    </form>

    <notifications style="top:5%;" width="35%" group="success" position="top center" />
    <notifications style="top:5%;" width="35%" group="error" position="top center" />
  </div>
</template>

<script>
import LoadingSpinner from '@/components/templates/LoadingSpinner.vue';
export default {
  components: { LoadingSpinner },
  data() {
    return {
      passwordData: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      has_error: false,
      loader: false,
      errors: {},
    };
  },
  methods: {
    updatePassword() {
      const userId=this.user.id;
      this.has_error=false;
      this.errors={};
      window.scrollTo(0, 0);

      // --- START CLIENT-SIDE VALIDATION ---
      let isValid=true;
      const { oldPassword, newPassword, confirmPassword }=this.passwordData;

      // Check Old Password
      if (!oldPassword) {
        // Using array syntax usually preferred if your template iterates over errors
        this.$set(this.errors, 'oldPassword', ['L\'ancien mot de passe est requis.']);
        isValid=false;
      }

      // Check New Password Length
      if (!newPassword) {
        this.$set(this.errors, 'newPassword', ['Le nouveau mot de passe est requis.']);
        isValid=false;
      } else if (newPassword.length<6) {
        this.$set(this.errors, 'newPassword', ['Le mot de passe doit contenir au moins 6 caractères.']);
        isValid=false;
      }

      // Check Confirmation Match
      if (newPassword!==confirmPassword) {
        this.$set(this.errors, 'confirmPassword', ['La confirmation ne correspond pas au mot de passe.']);
        isValid=false;
      }

      // If validation failed, stop here.
      if (!isValid) {
        this.has_error=true;
        this.$notify({
          group: "error",
          title: "Erreur !",
          type: "error",
          text: "Veuillez corriger les erreurs dans le formulaire.",
        });
        return;
      }

      // 2. Prepare Payload
      const payload={
        oldPassword: oldPassword,
        newPassword: newPassword,
        confirmPassword: confirmPassword,
      };

      this.loader=true;

      // 3. Send API Request
      this.$axios({
        url: `user/update-password/${userId}`,
        method: "POST",
        data: payload,
      })
        .then((response) => {
          this.loader=false;
          if (response.data.success) {
            // Clear password fields after successful update
            this.passwordData.oldPassword="";
            this.passwordData.newPassword="";
            this.passwordData.confirmPassword="";

            this.$notify({
              group: "success",
              title: "Bravo !",
              type: "success",
              text: "Mot de passe modifié avec succès!",
            });

            setTimeout(() => {
              this.$router.push({ name: "account" });
            }, 2000);
          }
        })
        .catch((err) => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          this.loader=false;
          let errorMessage="Une erreur est survenue !";

          // Check if detailed error data exists from backend validation
          if (err.response&&err.response.data&&err.response.data.data) {
            this.errors=err.response.data.data;
            this.has_error=true;
            errorMessage="Veuillez vérifier les champs et réessayer.";
          } else if (err.response&&err.response.data&&err.response.data.message) {
            // General API message from backend
            errorMessage=err.response.data.message;
          }

          this.$notify({
            group: "error",
            title: "Erreur !",
            type: "error",
            text: errorMessage,
          });
        });
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
};
</script>